var _path, _path2, _path3, _rect, _rect2, _rect3, _polygon, _path4, _circle, _path5, _polygon2, _polygon3, _polygon4, _path6, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path7, _path8, _circle2, _circle3, _path9, _path10, _polygon5, _rect10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFillForms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e4efdc2f-150c-4196-a68d-a8467dcc9971",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1012.29306,
    height: 636.61261,
    viewBox: "0 0 1012.29306 636.61261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fill_forms") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M472.64653,398.128s83,4,88,33-97,3-97,3Z",
    transform: "translate(-93.85347 -131.6937)",
    fill: "#a0616a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M341.64653,306.128s14,4,25,28,33,46,33,46l89,17-15,45-85-11-53-30Z",
    transform: "translate(-93.85347 -131.6937)",
    fill: "#575a89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M341.64653,306.128s14,4,25,28,33,46,33,46l89,17-15,45-85-11-53-30Z",
    transform: "translate(-93.85347 -131.6937)",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 824.29306,
    y: 92.93432,
    width: 105,
    height: 2,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 409.29306,
    y: 92.93432,
    width: 333,
    height: 2,
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.29306,
    y: 333.93432,
    width: 789,
    height: 301,
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "115.793 128.434 124.793 185.434 186.793 188.434 179.793 104.434 115.793 128.434",
    fill: "#a0616a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144.14653,640.628l-3,126h94l14-50,11,50h98s2-144-9-145S144.14653,640.628,144.14653,640.628Z",
    transform: "translate(-93.85347 -131.6937)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 135.79306,
    cy: 89.43432,
    r: 54,
    fill: "#a0616a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138.64653,646.128l28-138-37-183,85.21434-31.97582,41.78566-5.02418,21.00654-3.92147,14.99346,3.92147s60,15,63,26-12,101-12,101l-14,74,31,133s-129,44-220,24Z",
    transform: "translate(-93.85347 -131.6937)",
    fill: "#575a89"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "82.293 243.934 82.293 280.934 200.285 281.095 88.293 268.934 82.293 243.934",
    opacity: 0.1
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "72.159 346.12 220.293 324.934 72.159 366.89 72.159 346.12",
    opacity: 0.1
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "307.293 248.934 291.412 306.159 318.293 250.822 307.293 248.934",
    opacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M274.08747,166.97162l9.93007-3.97545s-20.76282-22.85871-49.65048-20.8709l8.12483-8.94481s-19.86015-7.95077-37.9148,12.92013c-9.491,10.97136-20.47216,23.86767-27.31776,38.39517H166.62491l4.4384,9.77288-15.53444,9.77288,15.94458-1.75541a54.612,54.612,0,0,0-.43268,16.21013,20.97371,20.97371,0,0,0,7.68035,13.72061h0s12.3151-25.49107,12.3151-29.46652v9.93858s9.93007-8.94467,9.93007-14.90777l5.41635,6.957,2.70817-10.93248,33.40108,10.93248-5.41635-8.94468,20.76283,2.98155-8.12483-10.93248s23.471,12.92013,24.37393,23.85261c.90262,10.93232,7.77269,21.29141,7.77269,21.29141S300.26671,181.8794,274.08747,166.97162Z",
    transform: "translate(-93.85347 -131.6937)",
    fill: "#2f2e41"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 233.29306,
    y: 234.93432,
    width: 384,
    height: 401,
    fill: "#d0cde1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 273.29306,
    y: 322.93432,
    width: 284,
    height: 40,
    fill: "#6c63ff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 322.11632,
    y: 428.93432,
    width: 185.99441,
    height: 20,
    fill: "#6c63ff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 322.47538,
    y: 463.93432,
    width: 185.99441,
    height: 20,
    fill: "#6c63ff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 322.83445,
    y: 498.93432,
    width: 92.9972,
    height: 20,
    fill: "#6c63ff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 519.29306,
    y: 599.93432,
    width: 43,
    height: 20,
    fill: "#6c63ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M299.64653,417.128s87-13,100,6-92,29-92,29Z",
    transform: "translate(-93.85347 -131.6937)",
    fill: "#a0616a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M139.64653,324.128h-6.26587a10.21521,10.21521,0,0,0-6.9558,2.707c-5.94794,5.52277-18.52459,19.7749-23.77833,45.293-7,34-19,100,8,105s204-19,204-19l-13-46-128,1s2-22-2-36S139.64653,324.128,139.64653,324.128Z",
    transform: "translate(-93.85347 -131.6937)",
    fill: "#575a89"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 409.29306,
    cy: 93.93432,
    r: 41,
    fill: "#d0cde1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 596.29306,
    cy: 93.93432,
    r: 41,
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M877.14653,267.628a42,42,0,1,1,42-42A42.0475,42.0475,0,0,1,877.14653,267.628Zm0-82a40,40,0,1,0,40,40A40.04551,40.04551,0,0,0,877.14653,185.628Z",
    transform: "translate(-93.85347 -131.6937)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.14653,267.628a42,42,0,1,1,42-42A42.0475,42.0475,0,0,1,1064.14653,267.628Zm0-82a40,40,0,1,0,40,40A40.04551,40.04551,0,0,0,1064.14653,185.628Z",
    transform: "translate(-93.85347 -131.6937)",
    fill: "#3f3d56"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "403.641 111.377 385.873 87.688 392.273 82.887 404.506 99.197 460.745 42.959 466.401 48.615 403.641 111.377",
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 16.49572,
    y: 633.8306,
    width: 816.59467,
    height: 2.78201,
    fill: "#3f3d56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillForms);
export default __webpack_public_path__ + "static/media/fill_forms.d68d2ab9fc2389727549317c2db1f16e.svg";
export { ForwardRef as ReactComponent };